<template>
  <section class="section pruebas-section" id="pruebas">
    <div class="pruebas-pattern"></div>
    <div class="wrap" style="position: relative">
      <div class="section-head">
        <div>
          <div class="eyebrow-line">10 estaciones</div>
          <h2><span class="display-italic-skew">PRUEBAS</span></h2>
        </div>
        <div class="tabs">
          <button :class="{ active: tab === 'pro' }" @click="tab = 'pro'">Categoría Pro</button>
          <button :class="{ active: tab === 'open' }" @click="tab = 'open'">Categoría Open</button>
        </div>
      </div>

      <div class="pruebas-scroll">
      <div class="pruebas-table">
        <div class="pruebas-row pruebas-head">
          <span class="cell n">#</span>
          <span class="cell name">Prueba</span>
          <span class="cell num">MTS</span>
          <span class="cell num">REPS</span>
          <span class="cell num">Hombre</span>
          <span class="cell num">Mujer</span>
        </div>
        <div v-for="r in rows" :key="r.n" class="pruebas-row">
          <span class="cell n">{{ r.n }}</span>
          <span class="cell name">{{ r.name }}</span>
          <span class="cell num">{{ r.mts }}</span>
          <span class="cell num">{{ r.reps }}</span>
          <span class="cell num accent">{{ r.m }}</span>
          <span class="cell num accent">{{ r.f }}</span>
        </div>
      </div>
      </div>

      <div class="pruebas-obs">
        <div class="eyebrow-line" style="color: rgba(255,255,255,0.7); margin-bottom: 12px">Observaciones</div>
        <ul>
          <li><strong>Carrera de {{ carrera }}</strong> entre cada prueba.</li>
          <li>Parejas <strong>mixtas</strong>: se aplica peso masculino.</li>
          <li>Clasificación por <strong>mejor tiempo total de la pareja</strong>.</li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed } from 'vue'

const tab = ref('pro')

const pro = [
  { n: 1,  name: 'Burpees broad jump',        mts: '80 m',   reps: '—',  m: '80 m',             f: '80 m' },
  { n: 2,  name: 'Sky',                       mts: '1000 m', reps: '—',  m: '1000 m ergómetro', f: '1000 m ergómetro' },
  { n: 3,  name: 'Sit-ups con wallball',      mts: '—',      reps: '75', m: '12 kg',            f: '9 kg' },
  { n: 4,  name: 'Row',                       mts: '1000 m', reps: '—',  m: '1000 m ergómetro', f: '1000 m ergómetro' },
  { n: 5,  name: 'Assault Bike',              mts: '—',      reps: '—',  m: '75 cal',           f: '75 cal' },
  { n: 6,  name: 'Thrusters',                 mts: '—',      reps: '75', m: '2 × 15 kg',        f: '2 × 12,5 kg' },
  { n: 7,  name: 'Hand release push-ups',     mts: '—',      reps: '75', m: '—',                f: '—' },
  { n: 8,  name: 'Russian Kettlebell Swing',  mts: '—',      reps: '75', m: '32 kg',            f: '24 kg' },
  { n: 9,  name: 'Alternating Sandbag Lunges',mts: '—',      reps: '75', m: '25 kg',            f: '20 kg' },
  { n: 10, name: 'Wallball',                  mts: '—',      reps: '75', m: '9 kg',             f: '6 kg' },
]

const open = [
  { n: 1,  name: 'Burpees broad jump',        mts: '80 m',  reps: '—',  m: '80 m',             f: '80 m' },
  { n: 2,  name: 'Sky',                       mts: '750 m', reps: '—',  m: '750 m ergómetro',  f: '750 m ergómetro' },
  { n: 3,  name: 'Sit-ups con wallball',      mts: '—',     reps: '50', m: '9 kg',             f: '6 kg' },
  { n: 4,  name: 'Row',                       mts: '750 m', reps: '—',  m: '750 m ergómetro',  f: '750 m ergómetro' },
  { n: 5,  name: 'Assault Bike',              mts: '—',     reps: '—',  m: '50 cal',           f: '50 cal' },
  { n: 6,  name: 'Thrusters',                 mts: '—',     reps: '50', m: '2 × 12,5 kg',      f: '2 × 10 kg' },
  { n: 7,  name: 'Hand release push-ups',     mts: '—',     reps: '50', m: '—',                f: '—' },
  { n: 8,  name: 'Russian Kettlebell Swing',  mts: '—',     reps: '50', m: '24 kg',            f: '16 kg' },
  { n: 9,  name: 'Alternating Sandbag Lunges',mts: '—',     reps: '50', m: '20 kg',            f: '10 kg' },
  { n: 10, name: 'Wallball',                  mts: '—',     reps: '50', m: '6 kg',             f: '4 kg' },
]

const rows = computed(() => tab.value === 'pro' ? pro : open)
const carrera = computed(() => tab.value === 'pro' ? '750 m' : '500 m')
</script>
